import React from 'react';
import brand from '../data/brand.json';
import lockupAvif480 from '../assets/logo/sbl-lockup-480.avif';
import lockupAvif960 from '../assets/logo/sbl-lockup-960.avif';
import lockupWebp480 from '../assets/logo/sbl-lockup-480.webp';
import lockupWebp960 from '../assets/logo/sbl-lockup-960.webp';
import lockupPng480 from '../assets/logo/sbl-lockup-480.png';
import lockupPng960 from '../assets/logo/sbl-lockup-960.png';
import markAvif112 from '../assets/logo/sbl-mark-112.avif';
import markAvif224 from '../assets/logo/sbl-mark-224.avif';
import markWebp112 from '../assets/logo/sbl-mark-112.webp';
import markWebp224 from '../assets/logo/sbl-mark-224.webp';
import markPng112 from '../assets/logo/sbl-mark-112.png';
import markPng224 from '../assets/logo/sbl-mark-224.png';

/**
 * Brand images. Files are generated by `brand/build-logo.py` (transparent AVIF → WebP → PNG fallback).
 * The artwork has black text, so use it on light backgrounds only.
 */
interface Props { className?: string; alt?: string; sizes?: string; priority?: boolean }

export const LogoLockup: React.FC<Props> = ({ className, alt = 'Skin by Lizzy Med Spa: aesthetics, skincare, confidence', sizes = '240px' }) => {
  const [w, h] = brand.dims.lockup;
  return (
    <picture>
      <source type="image/avif" srcSet={`${lockupAvif480} 480w, ${lockupAvif960} 960w`} sizes={sizes} />
      <source type="image/webp" srcSet={`${lockupWebp480} 480w, ${lockupWebp960} 960w`} sizes={sizes} />
      <img className={className} src={lockupPng960} srcSet={`${lockupPng480} 480w, ${lockupPng960} 960w`} sizes={sizes} width={w} height={h} alt={alt} loading="lazy" decoding="async" />
    </picture>
  );
};

/** Monogram only. Decorative by default because the visible wordmark text sits next to it. */
export const LogoMark: React.FC<Props> = ({ className, alt = '', sizes = '60px', priority }) => {
  const [w, h] = brand.dims.mark;
  return (
    <picture>
      <source type="image/avif" srcSet={`${markAvif112} 112w, ${markAvif224} 224w`} sizes={sizes} />
      <source type="image/webp" srcSet={`${markWebp112} 112w, ${markWebp224} 224w`} sizes={sizes} />
      <img className={className} src={markPng224} srcSet={`${markPng112} 112w, ${markPng224} 224w`} sizes={sizes} width={w} height={h} alt={alt} decoding="async" {...(priority ? { fetchPriority: 'high' as const } : { loading: 'lazy' as const })} />
    </picture>
  );
};
